export const SERVICE_REQUEST_TYPES = [
  { value: 'None', label: 'None' },
  { value: 'OffboardUser', label: 'Return' },
  { value: 'DeployInventory', label: 'Deploy' },
  { value: 'AdvDeviceReplacement', label: 'ADR' },
  { value: 'TechRefresh', label: 'Refresh' }
];
